<div class="stp-import-container" [class.panel-acik]="ayarlarPanelAcik">

    <!-- Dosya Bilgisi (Tek dosya) -->
    <div class="dosya-bilgisi" *ngIf="dosya && !cokluDosyaModu">
        <div class="dosya-ikon">
            <i class="icon file alternate outline"></i>
        </div>
        <div class="dosya-detay">
            <div class="dosya-isim">{{ dosya.name }}</div>
            <div class="dosya-boyut">{{ dosyaBoyutu }}</div>
        </div>
    </div>

    <!-- Çoklu Dosya Bilgisi -->
    <div class="dosya-bilgisi coklu" *ngIf="cokluDosyaModu">
        <div class="dosya-ikon">
            <i class="icon copy outline"></i>
        </div>
        <div class="dosya-detay">
            <div class="dosya-isim">{{ dosyaSayisi }} dosya seçildi</div>
            <div class="dosya-liste" *ngIf="dosyaListesi.length > 0">
                <div class="dosya-liste-item" *ngFor="let isim of dosyaListesi.slice(0, 5); trackBy: trackByDosyaIsim">
                    <i class="icon file outline mini"></i>
                    {{ isim }}
                </div>
                <div class="dosya-liste-more" *ngIf="dosyaListesi.length > 5">
                    ... ve {{ dosyaListesi.length - 5 }} dosya daha
                </div>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">

        <!-- Import Yöntemi -->
        <div class="form-section">
            <div class="section-title">Import Yöntemi</div>
            <div class="radio-grup">
                <label class="radio-item" [class.secili]="options.importMethod === 'occt-import-js'">
                    <input
                        type="radio"
                        name="importMethod"
                        value="occt-import-js"
                        [(ngModel)]="options.importMethod"
                        (change)="importMethodDegisti()">
                    <span class="radio-label">
                        <strong>occt-import-js</strong>
                        <small>Hızlı, hafif</small>
                    </span>
                </label>

                <label class="radio-item" [class.secili]="options.importMethod === 'opencascade-js'">
                    <input
                        type="radio"
                        name="importMethod"
                        value="opencascade-js"
                        [(ngModel)]="options.importMethod"
                        (change)="importMethodDegisti()">
                    <span class="radio-label">
                        <strong>OpenCascade.js</strong>
                        <small>Renkli, 65.9 MB</small>
                    </span>
                    <button
                        *ngIf="options.importMethod === 'opencascade-js'"
                        class="settings-trigger"
                        (click)="ayarlarPanelAc('tessellation'); $event.stopPropagation()">
                        <i class="icon cog"></i>
                    </button>
                </label>
            </div>
        </div>

        <!-- Tessellation Kalitesi -->
        <div class="form-section">
            <div class="section-title">Tessellation Kalitesi</div>
            <div class="preset-grid">
                <button
                    *ngFor="let preset of kalitePresetleri; let i = index; trackBy: trackByPresetIsim"
                    class="preset-btn"
                    [class.active]="seciliPreset === i"
                    (click)="seciliPreset = i; presetDegisti()"
                    [title]="preset.aciklama">
                    {{ preset.isim }}
                </button>
            </div>
            <div class="kalite-bilgi" *ngIf="kalitePresetleri[seciliPreset] as preset">
                <small>{{ preset.aciklama }}</small>
            </div>

            <div class="iki-sutun">
                <div class="form-row">
                    <label>Lineer <small>mm</small></label>
                    <div class="input-group">
                        <input type="number" [(ngModel)]="options.linearDeflection" (ngModelChange)="manuelDegerDegisti()" min="0.001" max="10" step="0.01" class="number-input">
                    </div>
                </div>
                <div class="form-row">
                    <label>Açısal <small>derece</small></label>
                    <div class="input-group">
                        <input type="number" [(ngModel)]="options.angularDeflection" (ngModelChange)="manuelDegerDegisti()" min="1" max="90" step="1" class="number-input">
                    </div>
                </div>
            </div>
        </div>

        <!-- Ek Secenekler -->
        <div class="form-section">
            <div class="section-title">Secenekler</div>

            <div class="iki-sutun">
                <label class="checkbox-item" *ngIf="options.importMethod === 'opencascade-js'">
                    <input type="checkbox" [(ngModel)]="options.useColors">
                    <span>Renkleri kullan</span>
                </label>
                <div class="form-row" [class.tam-genis]="options.importMethod !== 'opencascade-js'">
                    <label>Gruplama</label>
                    <select [(ngModel)]="options.gruplama" class="select-input">
                        <option value="yok">Yok</option>
                        <option value="hiyerarşik">Hiyerarşik</option>
                    </select>
                </div>
            </div>

            <div class="iki-sutun">
                <label class="checkbox-item">
                    <input type="checkbox" [(ngModel)]="options.autoCenter">
                    <span>Merkeze al</span>
                </label>
                <label class="checkbox-item">
                    <input type="checkbox" [(ngModel)]="options.autoFit">
                    <span>Kameraya sığdır</span>
                </label>
            </div>

            <div class="form-row">
                <label>Ölçek Çarpanı <small>1 = değişim yok</small></label>
                <div class="input-group">
                    <input type="number" [(ngModel)]="options.scaleFactor" min="0.001" max="1000" step="0.1" class="number-input">
                </div>
            </div>
        </div>

        <!-- Render Ayarları -->
        <div class="form-section">
            <div class="section-title">Render Ayarları</div>

            <div class="iki-sutun">
                <label class="checkbox-item">
                    <input type="checkbox" [(ngModel)]="options.doubleSided">
                    <span>Çift yüzeyli</span>
                </label>
                <label class="checkbox-item">
                    <input type="checkbox" [(ngModel)]="options.smoothNormals">
                    <span>Normal yumuşatma</span>
                </label>
            </div>

            <div class="iki-sutun">
                <div class="form-row">
                    <label>Renk <small>varsayılan</small></label>
                    <div class="input-group">
                        <input type="color" [(ngModel)]="options.defaultColor">
                    </div>
                </div>
                <div class="form-row">
                    <label>Opaklık <small>0-1</small></label>
                    <div class="input-group">
                        <input type="number" [(ngModel)]="options.defaultOpacity" min="0" max="1" step="0.05" class="number-input">
                    </div>
                </div>
            </div>

            <div class="form-row">
                <label>Sharp Edge Eşiği <small>keskin kenar açısı</small></label>
                <div class="input-group">
                    <input type="number" [(ngModel)]="options.edgeThresholdAngle" min="0" max="90" step="1" class="number-input">
                    <span class="unit">°</span>
                </div>
            </div>
        </div>

    </div>

    <!-- Android-Style Settings Panel -->
    <div class="settings-panel" [class.open]="ayarlarPanelAcik">

        <div class="panel-header">
            <button class="back-btn" (click)="ayarlarPanelKapat()">
                <i class="icon arrow left"></i>
            </button>
            <div class="panel-title">
                {{ aktifAyarPaneli === 'tessellation' ? 'Tessellation' : 'Gelişmiş' }}
            </div>
            <div class="header-spacer"></div>
        </div>

        <div class="panel-content">

            <!-- TESSELLATION PANEL -->
            <div class="panel-section" *ngIf="aktifAyarPaneli === 'tessellation'">

                <div class="form-section">
                    <div class="section-title">Kalite Preset</div>
                    <div class="preset-grid">
                        <button
                            *ngFor="let preset of kalitePresetleri; let i = index; trackBy: trackByPresetIsim"
                            class="preset-btn"
                            [class.active]="seciliPreset === i"
                            (click)="seciliPreset = i; presetDegisti()">
                            {{ preset.isim }}
                        </button>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title">Parametreler</div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>Lineer <small>mm</small></label>
                            <div class="input-group">
                                <input type="number" [(ngModel)]="options.linearDeflection" (ngModelChange)="manuelDegerDegisti()" min="0.001" max="10" step="0.01" class="number-input">
                            </div>
                        </div>
                        <div class="form-row">
                            <label>Açısal <small>°</small></label>
                            <div class="input-group">
                                <input type="number" [(ngModel)]="options.angularDeflection" (ngModelChange)="manuelDegerDegisti()" min="1" max="90" step="1" class="number-input">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Min Triangle <small>minimum boyut</small></label>
                        <div class="input-group">
                            <input type="number" [(ngModel)]="options.readParams!.minSize" min="0.001" max="1" step="0.001" class="number-input">
                            <span class="unit">mm</span>
                        </div>
                    </div>

                    <div class="iki-sutun">
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.relativeMode">
                            <span>Göreceli mod</span>
                        </label>
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.readParams!.inParallel">
                            <span>Multi-thread</span>
                        </label>
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.readParams!.internalVerticesMode">
                            <span>Internal vertices</span>
                        </label>
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.readParams!.controlSurfaceDeflection">
                            <span>Surface defl.</span>
                        </label>
                    </div>
                </div>

                <div class="navigation-section">
                    <button class="nav-btn" (click)="aktifAyarPaneli = 'gelismis'">
                        <span>Gelişmiş Ayarlar</span>
                        <i class="icon arrow right"></i>
                    </button>
                </div>

            </div>

            <!-- GELİŞMİŞ PANEL -->
            <div class="panel-section" *ngIf="aktifAyarPaneli === 'gelismis'">

                <div class="navigation-section">
                    <button class="nav-btn" (click)="aktifAyarPaneli = 'tessellation'">
                        <i class="icon arrow left"></i>
                        <span>Tessellation</span>
                    </button>
                </div>

                <div class="form-section">
                    <div class="section-title">Precision</div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>Mode</label>
                            <select [(ngModel)]="options.readParams!.precisionMode" class="select-input">
                                <option [value]="0">File</option>
                                <option [value]="1">User</option>
                            </select>
                        </div>
                        <div class="form-row" *ngIf="options.readParams!.precisionMode === 1">
                            <label>Value <small>mm</small></label>
                            <div class="input-group">
                                <input type="number" [(ngModel)]="options.readParams!.precisionVal" min="0.0001" max="1" step="0.0001" class="number-input">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Max Precision <small>maksimum tolerans</small></label>
                        <div class="input-group">
                            <input type="number" [(ngModel)]="options.readParams!.maxPrecisionVal" min="0.01" max="10" step="0.01" class="number-input">
                            <span class="unit">mm</span>
                        </div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title">STEP Schema</div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>Schema</label>
                            <select [(ngModel)]="options.readParams!.stepSchema" class="select-input">
                                <option value="AP203">AP203</option>
                                <option value="AP214">AP214</option>
                                <option value="AP242">AP242</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label>Curve Mode</label>
                            <select [(ngModel)]="options.readParams!.surfaceCurveMode" class="select-input">
                                <option [value]="0">Default</option>
                                <option [value]="3">3D</option>
                            </select>
                        </div>
                    </div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>Product</label>
                            <select [(ngModel)]="options.readParams!.productMode" class="select-input">
                                <option value="0">OFF</option>
                                <option value="1">ON</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label>Assembly</label>
                            <select [(ngModel)]="options.readParams!.assemblyLevel" class="select-input">
                                <option [value]="0">Root</option>
                                <option [value]="1">Single</option>
                                <option [value]="2">Full</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="section-title">Advanced</div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>Unit</label>
                            <select [(ngModel)]="options.readParams!.unit" class="select-input">
                                <option value="MM">MM</option>
                                <option value="CM">CM</option>
                                <option value="M">M</option>
                                <option value="INCH">INCH</option>
                                <option value="FT">FT</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label>Non-Manifold</label>
                            <select [(ngModel)]="options.readParams!.nonManifold" class="select-input">
                                <option [value]="0">OFF</option>
                                <option [value]="1">ON</option>
                            </select>
                        </div>
                    </div>

                    <div class="iki-sutun">
                        <div class="form-row">
                            <label>IDEAS</label>
                            <select [(ngModel)]="options.readParams!.ideasMode" class="select-input">
                                <option [value]="0">OFF</option>
                                <option [value]="1">ON</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label>Regularity <small>rad</small></label>
                            <div class="input-group">
                                <input type="number" [(ngModel)]="options.readParams!.encodeRegularityAngle" min="0.001" max="1" step="0.001" class="number-input">
                            </div>
                        </div>
                    </div>

                    <label class="checkbox-item">
                        <input type="checkbox" [(ngModel)]="options.readParams!.allShapes">
                        <span>Read all shapes</span>
                    </label>
                </div>

                <div class="form-section" *ngIf="options.importMethod === 'opencascade-js'">
                    <div class="section-title">Shape Processing</div>

                    <div class="iki-sutun">
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.readParams!.shapeHealing">
                            <span>Shape healing</span>
                        </label>
                        <label class="checkbox-item">
                            <input type="checkbox" [(ngModel)]="options.readParams!.mergeBodies">
                            <span>Bodyleri birleştir</span>
                        </label>
                    </div>

                    <div class="form-row">
                        <label>Kısa Edge Toleransı</label>
                        <div class="input-group">
                            <input type="number" [(ngModel)]="options.readParams!.shortEdgeTolerance" min="0.0001" max="1" step="0.0001" class="number-input">
                            <span class="unit">mm</span>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

    <!-- Overlay -->
    <div class="panel-overlay" [class.visible]="ayarlarPanelAcik" (click)="ayarlarPanelKapat()"></div>

    <!-- Butonlar -->
    <div class="action-buttons">
        <button class="btn btn-cancel" (click)="onbellekTemizle()"
                title="Kayıtlı tesselation önbelleğini temizle (disk)">
            <i class="icon trash"></i>
            {{ onbellekTemizlendi ? 'Temizlendi ✓' : 'Önbellek' }}
        </button>
        <button class="btn btn-cancel" (click)="kapa()">
            <i class="icon close"></i>
            İptal
        </button>
        <button class="btn btn-primary" (click)="importBaslat()">
            <i class="icon download"></i>
            Import
        </button>
    </div>

</div>
